import React from 'react';
import {getLocaleContent} from '@helper/locale-content.js';
import {useRouter} from 'next/router';
export default function ContactIntro({onClick}) {
    const {locale} = useRouter();
    return (
        <div className="contact-intro" onClick={onClick}>
            <div className="contact-intro-content">
                <h3>{getLocaleContent(locale, 'page.contact-us.title')}</h3>
                <p>{getLocaleContent(locale, 'page.contact-form.description')}</p>
            </div>

            <div className="contact-intro-action">
                <img src="/bw_image/max_btn.svg" alt="open" />
            </div>
        </div>
    );
}
